import React, { useEffect, useState } from 'react'
import { graphql } from 'gatsby'
import Slider from 'react-slick'
import { HtmlTag } from '../libs/helpers'
import colorHpsp from '../images/comparisonChart/colorHpsp.png'
import colorUSU from '../images/comparisonChart/colorUSU.png'
import accreditedMedical from '../images/comparisonChart/accreditedMedical.png'
import usuMap from '../images/comparisonChart/usuMap.png'
import trainingOfficerSilluehotte from '../images/comparisonChart/trainingOfficerSilluehotte.png'
import expansiveMilTraining from '../images/comparisonChart/expansiveMilTraining.png'
import calenderIcon from '../images/comparisonChart/calenderIcon.png'

import * as styles from './comparison.module.scss'

const ComparisonChart = ({ title }) => {
  const [shouldInitSlick, setShouldInitSlick] = useState(false)
  let settings = {}

  settings = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 480,
        variableWidth: true,
      },
    ],
  }
  useEffect(() => {
    const handleResize = () => {
      setShouldInitSlick(window.innerWidth < 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const listItems = [
    {
      title: 'Program',
      items: [
        {
          imgSrc: colorHpsp,
          link: '/applying-and-what-to-expect/medical-school-programs/hpsp',
          copy: 'Health Professions Scholarship Program',
          className: styles['red_text_group'],
        },
        {
          imgSrc: colorUSU,
          link: '/applying-and-what-to-expect/medical-school-programs/usu',
          copy: 'Uniformed Services University of Health Sciences',
          className: styles['red_text_group'],
        },
      ],
    },
    {
      title: 'Location',
      items: [
        {
          imgSrc: accreditedMedical,
          copy: 'Any accredited medical school',
          className: styles['black_text_group'],
        },
        {
          imgSrc: usuMap,
          copy: 'USU (Bethesda, MD)*',
          className: styles['black_text_group'],
        },
      ],
    },
    {
      title: 'Tuition & Benefits',
      items: [
        {
          copy: {
            items: ['Tuition paid by Service branch', "45 days' pay & signing bonus", 'Living stipend'],
          },
          className: styles['black_text_group'],
        },
        {
          copy: {
            items: ['No tuition costs or fees', 'Full salary & benefits', 'Housing allowance'],
          },
          className: styles['black_text_group'],
        },
      ],
    },
    {
      title: 'Training',
      items: [
        {
          imgSrc: trainingOfficerSilluehotte,
          copy: 'Military officer training',
          className: styles['black_text_group'],
        },
        {
          imgSrc: expansiveMilTraining,
          copy: 'Expansive military medical training',
          className: styles['black_text_group'],
        },
      ],
    },
    {
      title: 'Service Commitment',
      items: [
        {
          imgSrc: calenderIcon,
          copy: '1 year of service per year of scholarship**',
          className: styles['black_text_group'],
        },
        {
          imgSrc: calenderIcon,
          copy: '7-years service commitment',
          className: styles['black_text_group'],
        },
      ],
    },
  ]

  return (
    <>
      <section className={styles['comparison_chart_wrapper']}>
        <div className={styles['container']}>
          {title && <HtmlTag tagName={title.header}>{title.copy}</HtmlTag>}
          <div className={styles['comparison_chart_content']}>
            {shouldInitSlick ? (
              <Slider
                {...settings}
                className={`${styles['row_container']} ${styles['comparison_chart_mobile_carousel']}`}
              >
                {listItems.map((listItem, index) => (
                  <div key={index} className={styles['row_content']}>
                    <h4>{listItem.title}</h4>
                    {listItem.items.map((item, itemIndex) => (
                      <div key={itemIndex} className={styles['grouped_row_item']}>
                        {item.imgSrc && <img src={item.imgSrc} alt={item.copy} />}
                        <div className={item.className}>
                          {item.link ? (
                            <>
                              {typeof item.copy === 'object' ? (
                                <ul>
                                  {item.copy.items.map((copyItem, copyIndex) => (
                                    <li key={copyIndex}>
                                      <strong>{copyItem}</strong>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className={styles['rtecenter']}>
                                  <a href={item.link}>
                                    <strong>{item.copy}</strong>
                                  </a>
                                </p>
                              )}
                            </>
                          ) : (
                            <>
                              {typeof item.copy === 'object' ? (
                                <ul>
                                  {item.copy.items.map((copyItem, copyIndex) => (
                                    <li key={copyIndex}>{copyItem}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className={styles['rtecenter']}>
                                  <>{item.copy}</>
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </Slider>
            ) : (
              <ul className={`${styles['row_container']}`}>
                {listItems.map((listItem, index) => (
                  <li key={index} className={styles['row_content']}>
                    <h4>{listItem.title}</h4>
                    {listItem.items.map((item, itemIndex) => (
                      <div key={itemIndex} className={styles['grouped_row_item']}>
                        {item.imgSrc && <img src={item.imgSrc} alt={item.copy} />}
                        <div className={item.className}>
                          {item.link ? (
                            <>
                              {typeof item.copy === 'object' ? (
                                <ul>
                                  {item.copy.items.map((copyItem, copyIndex) => (
                                    <li key={copyIndex}>
                                      <strong>{copyItem}</strong>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className={styles['rtecenter']}>
                                  <a href={item.link}>
                                    <strong>{item.copy}</strong>
                                  </a>
                                </p>
                              )}
                            </>
                          ) : (
                            <>
                              {typeof item.copy === 'object' ? (
                                <ul>
                                  {item.copy.items.map((copyItem, copyIndex) => (
                                    <li key={copyIndex}>{copyItem}</li>
                                  ))}
                                </ul>
                              ) : (
                                <p className={styles['rtecenter']}>
                                  <>{item.copy}</>
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className={styles['comparison_chart_footer']}>
            <p>
              *For the first 18 months, and then students will be located at major military facilities around the United
              States for the remainder of medical school.
            </p>

            <p>**The U.S. Navy has a three-year option, with three-year minimum service commitment.</p>
          </div>
        </div>
      </section>
    </>
  )
}

export default ComparisonChart

export const query = graphql`
  fragment comparisonChartData on STRAPI__COMPONENT_SUPERCUSTOM_COMPARISON_CHART {
    title {
      copy
      header
    }
  }
`
